import { EasingType } from '../../../Utils/EasingType';

export type SegmentAverageDurationType = 'SegmentAverageDuration'; // 分段平均時間 (每一分段曲線使用相同的時間游動)
export const SEGEMENT_AVERAGE_DURATION = 'SegmentAverageDuration';

export type PathSegmentDataConfigType = {
    easing: EasingType | string;
};

export type PathSegmentDataType = {
    /**
     * [
     *  [x1, y1],
     *  [x2, y2],
     *  [x3, y3],
     * ]
     */
    points: number[][];
    config: PathSegmentDataConfigType;
};

export type SpeedCurveSegmentDataType = {
    /**
     * [
     *  [x1, y1],
     *  [x2, y2],
     *  [x3, y3],
     * ]
     */
    points: number[][];
};

export type PathEventDataType = {
    progress: number; // [0, 1]
    name: string;
};

export enum PathResizeMode {
    Fixed, // 固定路徑
    AllScale, // 依照起點終點整體縮放
    StartAndEndScale, // 依照起點終點縮放第一段/最後一段
}

export type PathDataConfigType = {
    easing: EasingType | string | SpeedCurveDataType | SegmentAverageDurationType;
    duration: number; // 表演的基礎時長 (單位: 毫秒)
    events: PathEventDataType[];
    fixedRotate: boolean; // 物件方向是否保持固定
    resizeMode: PathResizeMode; // 路徑縮放模式
    arcLength: number; // 曲線總長度
};

export type PathDataType = {
    name: string;
    segments: PathSegmentDataType[];
    config: PathDataConfigType;
};

export type SpeedCurveDataType = {
    name: string;
    segments: SpeedCurveSegmentDataType[];
};
